module.exports = __webpack_public_path__ + "static/img/pDR2.7f7d347a.png";